import { isInlineImageMime } from '@lib/mime'
import { GetFileType } from '@orbit/api-types'

/** File-card behavior shared by the member and public Files pages. */

/** Whether the file opens in the lightbox. Whitelist-gated, so HEIC and other
 * undecodable types render as plain file cards instead of a broken `<img>`. */
export const isViewableImage = (file: GetFileType): boolean => isInlineImageMime(file.mimeType)

/** "receipt.pdf" → "pdf"; no extension → "". */
export const getFileExtension = (fileName: string): string => {
	const parts = fileName.split('.')
	return parts.length > 1 ? parts[parts.length - 1] : ''
}

/** Open the stored file URL in a new tab, never handing the opener over. */
export const openFileInNewTab = (url: string): void => {
	window.open(url, '_blank', 'noopener,noreferrer')
}

/**
 * Download a file as a named blob. A non-OK response throws (a 403 must not
 * save an error page under the filename); any failure notifies `onError` and
 * falls back to opening the URL directly.
 */
export const downloadFile = async (file: GetFileType, onError?: () => void): Promise<void> => {
	try {
		const response = await fetch(file.url)
		if (!response.ok) throw new Error(`Download failed with status ${response.status}`)
		const blob = await response.blob()
		const link = document.createElement('a')
		link.href = URL.createObjectURL(blob)
		link.download = file.fileName
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
		URL.revokeObjectURL(link.href)
	} catch {
		onError?.()
		openFileInNewTab(file.url)
	}
}
